/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Pick_WarehouseInputs */

const vi_form_err_pick_warehouse = /** @type {(inputs: Form_Err_Pick_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn kho`)
};

/**

* @param {Form_Err_Pick_WarehouseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_pick_warehouse = /** @type {((inputs?: Form_Err_Pick_WarehouseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Pick_WarehouseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_pick_warehouse(inputs)
});